import { gql } from '@apollo/client';
/**
 * @fragment ActionFragment
 * @since 1.0.0
 */
export const ActionFragment = gql `
  fragment ActionFragment on Action {
    id
    title
    infos
    value
    createdAt
    updatedAt

    module {
      id
      tag
      title
    }
  }
`;
